/**
 * Base class for AI pilots. Concrete pilots (HelicopterAIPilot,
 * eventually FixedWingAIPilot, GroundVehicleAIPilot) implement update()
 * and may expose extra hooks like threaten() for dynamic behavior changes.
 */
export default class AIPilot {
  constructor() {
    this.state = 'idle';
  }

  // Subclasses override.
  update(_dt, _entity, _terrainCollider) {}

  // Future hook — called when the player targets/fires at this entity.
  // Default: no-op. Subclasses may transition into an evade state.
  threaten(_threat) {}
}
